export default __webpack_public_path__ + "static/media/033.42b10862.jpg";